import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { FormBaseComponent } from '../../../core/_base/form.base';
import { INgxCrudAction } from '../../_models/_crud-manage';

@Component({
  selector: 'ngx-crud-manage-layout',
  templateUrl: './ngx-crud-manage-layout.component.html',
  styleUrls: ['./ngx-crud-manage-layout.component.css']
})
export class NgxCrudManageLayoutComponent extends FormBaseComponent<any> implements OnInit {

  // actions
  @Input() actions: INgxCrudAction[] = [];
  // form group
  @Input() form: FormGroup;
  // on action perfomed
  @Output() onAction = new EventEmitter<INgxCrudAction>();

  // dialog key
  _dialogKey: string;

  constructor(injector: Injector,
    private confirmDialog: ConfirmationService) {
    super(injector);
  }

  ngOnInit(): void {
    // init dialog key
    this._dialogKey = `crud_action_layout_cd_${new Date().getTime()}`;
    // prepare default actions
    this.prepareDefaultActions();
  }

  private prepareDefaultActions() {
    if (!this.actions) {
      this.actions = [];
      this.actions.push({ key: 'cancel', name: 'Cancel', styleClass: 'p-button-sm p-button-outlined p-button-danger mr-2', validate: false, serviceCall: false });
      this.actions.push({ key: 'submit', name: 'Submit', styleClass: 'p-button-sm p-button-outlined', validate: true, serviceCall: true });
    }
  }

  handleAction(item: INgxCrudAction) {
    if (item.validate) {
      if (this.form.valid) {
        // check confirm action
        this.checkConfirmation(item, () => {
          this.onAction.emit(item);
        });
      }
      else {
        this.fireFormGroupValidation(this.form);
      }
    }
    else {
      // check confirm action
      this.checkConfirmation(item, () => {
        this.onAction.emit(item);
      });
    }
  }

  private checkConfirmation(action: INgxCrudAction, callback: () => void) {
    if (action.confirmMessage) {
      this.confirmDialog.confirm({
        header: 'Confirmation',
        message: action.confirmMessage,
        key: this._dialogKey,
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          callback();
        }
      })
    } else {
      callback();
    }
  }

}
